
import { defineComponent, PropType } from "vue";

import Action from "@/models/Action";
import Player from "@/models/Player";

import RolledDice from "@/components/Elements/RolledDice.vue";
import PlayerPicture from "@/components/Elements/PlayerPicture.vue";

export default defineComponent({
  inject: ["game"],
  props: {
    player: { type: Object as PropType<Player>, required: true },
  },
  computed: {
    isActive(): boolean {
      return this.game.activePlayerId === this.player.id;
    },
    isCurrentTurn(): boolean {
      return this.game.publicState?.currentTurn.player === this.player.id;
    },
    diceRoll(): [number, number] | null {
      return this.game.publicState?.currentTurn.eachDiceRoll ?? null;
    },
    availableActions(): Action[] {
      return this.game.availableActions;
    },
  },
  methods: {
    switchActivePlayer() {
      if (this.game.isDebug) {
        this.game.switchActivePlayer(this.player.id);
      }
    },
    rollDice() {
      this.game.rollDice();
    },
    pass() {
      this.game.pass();
    },
  },
  components: { RolledDice, PlayerPicture },
});
